import { render, staticRenderFns } from "./PainterMineTalk.vue?vue&type=template&id=24e0d9f6&scoped=true"
import script from "./PainterMineTalk.vue?vue&type=script&lang=js"
export * from "./PainterMineTalk.vue?vue&type=script&lang=js"
import style0 from "./PainterMineTalk.vue?vue&type=style&index=0&id=24e0d9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0d9f6",
  null
  
)

export default component.exports